export const ROUTE_STOCK = '/stock'
export const ROUTE_STOCK_OVERVIEW = `${ROUTE_STOCK}/overview`
export const ROUTE_STOCK_DEPOSIT = `${ROUTE_STOCK}/deposit`
export const ROUTE_STOCK_TRANSFER = `${ROUTE_STOCK}/transfer`
export const ROUTE_STOCK_STATS = `${ROUTE_STOCK}/stats`
export const ROUTE_STOCK_INVENTORY_LIST = `${ROUTE_STOCK}/inventories`
export const ROUTE_STOCK_INVENTORY = `${ROUTE_STOCK}/inventory`
export const ROUTE_STOCK_INVENTORY_DETAIL_NO_PARAMS = `${ROUTE_STOCK}/inventory-detail`
export const ROUTE_STOCK_INVENTORY_DETAIL = `${ROUTE_STOCK_INVENTORY_DETAIL_NO_PARAMS}/:id`
